export default "__VITE_ASSET__2f8f6afd__"